import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { loginFailure, signupSuccess, signupFailure, forgetPasswordSuccess, loginSuccess, onBoardingNavigationRequest, resetPasswordSuccess, meCallSuccess, permissionsCallSuccess, permissionsCallRequest } from "./onBoardingActions";
import { FORGET_PASSWORD_REQUEST, LOGIN_REQUEST, ME_CALL_REQUEST, PERMISSIONS_CALL_REQUEST, RESET_PASSWORD, SIGNUP_REQUEST, VERIFY_OTP } from "../../redux/action_constant";
import WebService from "../../utility/WebService";
import routePaths from "../../Navigation/routePaths";
import API from "../../utility/API-endPoints";
import { AuthState, ForgetPasswordFields, ForgetPasswordRequest, LoginFields, LoginRequest, onboardingResetPasswordRequest, reduxInitialState, userInterface } from "./onBoardingTypes";
import { toast } from "react-toastify";

export const getOnBoardingReducer = (state: reduxInitialState) => state.OnBoardingReducer;

const login = async (payload: LoginFields) => {
    const data = await WebService.postAPI({
        action: API.LOGIN, body: {
            email: payload.email,
            password: payload.password,
        }, id: "login_btn",
    }).then((res: any) => res).catch((e: any) => { return null })
    return data
};

const mecall = async () => {
    const data = await WebService.getAPI({
        action: API.ME, id: "login_btn",
    }).then((res: any) => res).catch((e: any) => { return null })
    return data
};

const permissionsCall = async () => {
    const data = await WebService.getAPI({
        action: API.PERMISSIONS, id: "permissions_btn",
    }).then((res: any) => res).catch((e: any) => { return null })
    return data
};

const signup = async (payload: LoginFields) => {
    // const { data } = await axios.post(
    //     "https://reqres.in/api/register",
    //     { ...payload },
    //     {
    //         headers: {
    //             "Content-Type": "application/json",
    //             Accept: "application/json",
    //         },
    //     }
    // );

    // return data;
};

const forgetPassword = async (payload: ForgetPasswordFields) => {
    const data = await WebService.postAPI({
        action: API.FORGET_PASSWORD, body: {
            email: payload.email,
        }, id: "forget_password_button",
    }).then((res: any) => res).catch((e: any) => { return null })
    return data
};

const verifyOTP = async ({ forgetPasswordOTP, forgetPasswordEmail }: AuthState) => {
    const data = await WebService.postAPI({
        action: API.VERIFY_OTP, body: {
            email: forgetPasswordEmail,
            otp: forgetPasswordOTP,
        }, id: "verify-otp-button",
    }).then((res: any) => res).catch((e: any) => { return null })
    return data
};

const resetPassword = async (payload: { email: string, password: string, otp: string }) => {
    const data = await WebService.postAPI({
        action: API.VERIFY_OTP, body: {
            email: payload.email,
            password: payload.password,
            otp: payload.otp,
        }, id: "reset_password_button",
    }).then((res: any) => res).catch((e: any) => { return null })
    return data
};

function* loginSaga(action: LoginRequest) {
    try {
        const response: { access_token: string } = yield call(login, {
            email: action.payload.values.email,
            password: action.payload.values.password,
        });
        if (!response) { throw new Error(); }
        localStorage.setItem("token", response.access_token);
        const meCallResponse: { result: userInterface } = yield call(mecall);
        if (!meCallResponse) { localStorage.clear(); throw new Error(); };
        yield put(loginSuccess({ token: response.access_token, user: meCallResponse.result }));
        yield put(permissionsCallRequest());
        yield put(onBoardingNavigationRequest(routePaths.HOME.path));

    } catch (e: any) {
        yield put(loginFailure({ error: e.message, }));
    }
};

function* signupSaga(action: any) {
    try {
        const response: { token: string } = yield call(signup, {
            email: action.payload.values.email,
            password: action.payload.values.password,
        });
        yield put(signupSuccess({ token: response.token }));
        action.payload.callback(response.token);
    } catch (e: any) {
        yield put(signupFailure({ error: e.message, }));
    }
};

function* forgetPasswordSaga(action: ForgetPasswordRequest) {
    try {
        const response: { message: string; } = yield call(forgetPassword, { email: action.payload.email });
        if (!response) { throw new Error(); }
        yield put(forgetPasswordSuccess({ email: action.payload.email }));
        yield put(onBoardingNavigationRequest(routePaths.FORGET_PASSWORD_VERIFY_OTP.path));
    } catch (e: any) { }
};

function* verifyOTPSaga() {
    try {
        const { forgetPasswordOTP, forgetPasswordEmail }: AuthState = yield select(getOnBoardingReducer);
        if (!forgetPasswordOTP || !forgetPasswordEmail) {
            yield put(onBoardingNavigationRequest(routePaths.FORGET_PASSWORD.path));
            return;
        }
        const response: { message: string; } = yield call(verifyOTP, { forgetPasswordOTP, forgetPasswordEmail } as AuthState);
        if (!response) { throw new Error(); }
        yield put(onBoardingNavigationRequest(routePaths.RESET_PASSWORD.path));
    } catch (e: any) { }
};

function* resetPasswordSaga(action: onboardingResetPasswordRequest) {
    try {
        const { forgetPasswordOTP, forgetPasswordEmail }: AuthState = yield select(getOnBoardingReducer);
        if (!forgetPasswordOTP || !forgetPasswordEmail) {
            yield put(onBoardingNavigationRequest(routePaths.FORGET_PASSWORD.path));
            return;
        }
        const response: { message: string; } = yield call(resetPassword, { email: forgetPasswordEmail, password: action.payload.password, otp: forgetPasswordOTP });
        if (!response) { throw new Error(); };
        toast.success(response.message);
        yield put(resetPasswordSuccess());
    } catch (e: any) { }
};

function* meCallRequestSaga() {
    try {
        const response: { result: userInterface } = yield call(mecall);
        if (!response) { throw new Error(); };
        yield put(meCallSuccess(response.result));
    } catch (e: any) { }
};

function* permissionsCallRequestSaga() {
    try {
        const response: { permissions: any[] } = yield call(permissionsCall);
        if (!response) { throw new Error(); }
        yield put(permissionsCallSuccess(response.permissions));
    } catch (e: any) {
        yield put(permissionsCallSuccess([]));
    }
}

function* onBoardingSaga() {
    yield all([takeLatest(LOGIN_REQUEST, loginSaga)]);
    yield all([takeLatest(SIGNUP_REQUEST, signupSaga)]);
    yield all([takeLatest(FORGET_PASSWORD_REQUEST, forgetPasswordSaga)]);
    yield all([takeLatest(VERIFY_OTP, verifyOTPSaga)]);
    yield all([takeLatest(RESET_PASSWORD, resetPasswordSaga)]);
    yield all([takeLatest(ME_CALL_REQUEST, meCallRequestSaga)]);
    yield all([takeLatest(PERMISSIONS_CALL_REQUEST, permissionsCallRequestSaga)]);
};

export default onBoardingSaga;